
import * as echarts from 'echarts'
import { computed, defineComponent, markRaw, nextTick, onBeforeUnmount, onMounted, ref, watchEffect } from 'vue'
// import ChinaJSON from '@/assets/data/china.json'
import { getTodayNowTime, getTodayStartTime } from '@/utils/date.util'
import { ThemeModule } from '@/store/modules/theme.module'
import { ThemeType } from '@/assets/data/theme'
import OpenTicketReportApi from '@/api/OpenTicketReportApi'

export default defineComponent({
  setup () {
    let timer = 0
    const option = {
      tooltip: {
        borderWidth: 0,
        trigger: 'item',
        padding: 8
      },
      visualMap: [{
        type: 'continuous',
        min: 0,
        max: 1000,
        realtime: true,
        itemWidth: 16,
        itemHieght: 80,
        left: 20,
        bottom: 20,
        orient: 'horizontal',
        indicatorIcon: '',
        handleStyle: {
          borderCap: 'square'
        }
      }],
      geo: {
        map: 'china',
        roam: true,
        zoom: 1.2,
        layoutCenter: ['50%', '70%'],
        layoutSize: '100%',
        itemStyle: {
          color: 'rgba(24, 144, 255, 0.1)'
        },
        emphasis: {
          itemStyle: {
            areaColor: 'rgba(24, 144, 255, 0.2)'
          }
        },
        select: {
          itemStyle: {
            areaColor: '#1890FF'
          }
        }
      },
      series: [
        {
          type: 'map',
          map: 'china',
          geoIndex: 0,
          zoom: 1.25,
          data: []
        }
      ]
    }
    //各省份的拼音
    const provincePinyin = {
      // 上海: 'shanghai',
      河北: 'hebei',
      山西: 'shanxi',
      内蒙古: 'neimenggu',
      辽宁: 'liaoning',
      吉林: 'jilin',
      黑龙江: 'heilongjiang',
      江苏: 'jiangsu',
      浙江: 'zhejiang',
      安徽: 'anhui',
      福建: 'fujian',
      江西: 'jiangxi',
      山东: 'shandong',
      河南: 'henan',
      湖北: 'hubei',
      湖南: 'hunan',
      广东: 'guangdong',
      广西: 'guangxi',
      海南: 'hainan',
      四川: 'sichuan',
      贵州: 'guizhou',
      云南: 'yunnan',
      西藏: 'xizang',
      陕西: 'shangxi',
      甘肃: 'gansu',
      青海: 'qinghai',
      宁夏: 'ningxia',
      新疆: 'xinjiang',
      // 北京: 'beijing',
      // 天津: 'tianjin',
      // 重庆: 'chongqing',
    };
    const myChart = ref<echarts.ECharts>()
    const themeColors = computed(() => ThemeModule.themeColors)
    const theme = computed(() => ThemeModule.themeType)

    function getThemeOption(currentTheme) {
      if (currentTheme === ThemeType.THEME_DARK) {
        return {
          tooltip: {
            extraCssText: 'background: linear-gradient(304.17deg, rgba(36, 176, 255, 0.6) -6.04%, rgba(9, 67, 132, 0.6) 85.2%); border-radius: 6px',
            formatter: (params) => {
              return `
                <div class="fs12 color-08">${params.name}</div>` +
                (!currentProvince.value ? `<div class="fs12 color-08" style="
                  min-width: 164px;
                  margin-top: 4px;
                  width: 100%;
                  height: 32px;
                  line-height:32px;
                  background: linear-gradient(90deg, #0E42D2 0%, #52C5FF 101.59%);
                  border-radius: 4px;
                  padding: 0 8px
                ">
                  <span>工单量</span>
                  <span style="float: right">${params.data?.ticketCount || '-'}</span>
                </div>` : '') +
                `<div class="fs12 color-08" style="
                  min-width: 164px;
                  margin-top: 4px;
                  width: 100%;
                  height: 32px;
                  line-height:32px;
                  background: linear-gradient(90deg, #0E42D2 0%, #52C5FF 101.59%);
                  border-radius: 4px;
                  padding: 0 8px
                ">
                  <span>客服数</span>
                  <span style="float: right">${params.data?.engineerCount || '-'}</span>
                </div>
              `
            }
          },
          visualMap: [{
            textStyle: {
              color: themeColors.value['font-color-06']
            },
            inRange: {
              color: ['#12131A', '#2D7EE7', '#1890FF']
            }
          }],
          geo: {
            itemStyle: {
              borderColor: themeColors.value['main-bg-color']
            },
            emphasis: {
              label: {
                color: '#fff'
              }
            },
            select: {
              label: {
                color: '#fff'
              }
            }
          }
        }
      } else if (currentTheme === ThemeType.THEME_BRIGHT) {
        return {
          tooltip: {
            extraCssText: 'background: linear-gradient(300.16deg, rgba(47, 129, 232, 0.6) 2.92%, rgba(78, 189, 253, 0.6) 84.87%); border-radius: 6px',
            formatter: (params) => {
              return `
                <div class="fs12 color-08">${params.name}</div>` +
                (!currentProvince.value ? `<div class="fs12 color-08" style="
                  min-width: 164px;
                  margin-top: 4px;
                  width: 100%;
                  height: 32px;
                  line-height:32px;
                  background: rgba(255, 255, 255, 0.8);
                  box-shadow: 6px 0px 20px rgba(34, 87, 188, 0.1);
                  border-radius: 4px;
                  padding: 0 8px
                ">
                  <span>工单量</span>
                  <span style="float: right">${params.data?.ticketCount || '-'}</span>
                </div>` : '') +
                `<div class="fs12 color-08" style="
                  min-width: 164px;
                  margin-top: 4px;
                  width: 100%;
                  height: 32px;
                  line-height:32px;
                  background: rgba(255, 255, 255, 0.8);
                  box-shadow: 6px 0px 20px rgba(34, 87, 188, 0.1);
                  border-radius: 4px;
                  padding: 0 8px
                ">
                  <span>客服数</span>
                  <span style="float: right">${params.data?.engineerCount || '-'}</span>
                </div>
              `
            }
          },
          visualMap: [{
            textStyle: {
              color: themeColors.value['font-color-06']
            },
            inRange: {
              color: ['#F7F8FA', '#2D7EE7', '#1890FF']
            }
          }],
          geo: {
            itemStyle: {
              borderColor: themeColors.value['main-bg-color']
            },
            emphasis: {
              label: {
                color: '#000'
              }
            },
            select: {
              label: {
                color: '#000'
              }
            }
          }
        }
      }
      return {};
    }
    watchEffect(() => {
      myChart.value && myChart.value.setOption(getThemeOption(theme.value))
    })

    // 当前选中省份
    const currentProvince = ref<string>('');
    function renderChart () {
      const ChinaJSON = require('@/assets/data/china.json');
      const chartDom = document.getElementById('ticket-china-map') as HTMLElement;
      myChart.value = markRaw(echarts.init(chartDom))
      echarts.registerMap('china', JSON.stringify(ChinaJSON))
      myChart.value.setOption(option);
      chartDom.removeAttribute("_echarts_instance_")
      myChart.value.on('click', (params: any) => {
        const pinyin = provincePinyin[params.name];
        // 查到对应省份拼音才可以下钻
        if (pinyin) {
          const mapJSON = require(`@/assets/data/${pinyin}.json`);
          echarts.registerMap(pinyin, JSON.stringify(mapJSON))
          nextTick(() => {
            loadData(params.name);
          });
        }
      });
    }
    // 返回中国地图
    function returnToChina () {
      nextTick(() => {
        loadData();
      });
    }
    async function loadData (province: string = '') {
      currentProvince.value = province;
      timer && clearTimeout(timer)
      let ticketData: any[] = [];
      let engineerData: any[] = [];
      const requests: any[] = [];
      const params: any = {
        startDate: getTodayStartTime(),
        endDate: getTodayNowTime()
      };
      if (province) params.province = province;
      requests.push(OpenTicketReportApi.statisticsTicketRequestLocationDistribution(params).then((res: any) => {
        ticketData = res || [];
      }))
      requests.push(OpenTicketReportApi.statisticsEngineerGeoLocationDistribution(params).then((res: any) => {
        engineerData = res || [];
      }))

      Promise.all(requests).then(() => {
        const dataMap: any = {};
        ticketData.forEach((item: any) => {
          if (!dataMap[item.name]) dataMap[item.name] = {};
          dataMap[item.name].ticketCount = item.value;
        })
        engineerData.forEach((item: any) => {
          if (!dataMap[item.name]) dataMap[item.name] = {};
          dataMap[item.name].engineerCount = item.value;
        })
        let maxCount = 0;
        let data: any[] = [];
        if (Object.keys(dataMap).length) {
          data = Object.keys(dataMap).map((key: string) => {
            const { ticketCount = 0, engineerCount = 0 } = dataMap[key];
            const value = ticketCount + engineerCount;
            maxCount = Math.max(maxCount, value)
            return {
              name: key,
              value,
              ticketCount,
              engineerCount
            }
          })
        } else {
          maxCount = 1000;
        }

        let geo = {};
        if (province) {
          const pinyin = provincePinyin[province];
          geo = {
            map: pinyin,
            zoom: 0.8,
            layoutCenter: ['50%', '50%'],
          }
        } else {
          geo = {
            map: 'china',
            zoom: 1.2,
            layoutCenter: ['50%', '70%'],
          }
        }
        const themeOption = mergeEchartsOptions(option, getThemeOption(theme.value))
        const _option = mergeEchartsOptions(themeOption, {
          visualMap: [{
            max: Math.max(maxCount, 10)
          }],
          geo,
          series: [
            {
              data: data
            }
          ]
        })
        myChart.value && myChart.value.setOption(_option, true)
        timer = setTimeout(() => {
          loadData(province);
        }, 10000)
      })

    }
    function mergeEchartsOptions(baseOptions, customOptions) {
      // 如果 customOptions 为 null 或 undefined，直接返回 baseOptions
      if (!customOptions) {
        return baseOptions;
      }
      // 深拷贝 baseOptions，避免直接修改原始配置
      const mergedOptions = deepCopy(baseOptions);

      // 遍历 customOptions，将其属性合并到 mergedOptions 中
      for (const key in customOptions) {
        if (Object.prototype.hasOwnProperty.call(customOptions, key)) {
          // 如果 mergedOptions 中存在相同的属性，则进行合并
          if (mergedOptions.hasOwnProperty(key)) {
            // 如果属性值为对象，则递归合并
            if (typeof mergedOptions[key] === 'object' && typeof customOptions[key] === 'object') {
              mergedOptions[key] = mergeEchartsOptions(mergedOptions[key], customOptions[key]);
            } else {
              // 否则直接覆盖
              mergedOptions[key] = customOptions[key];
            }
          } else {
            // 如果 mergedOptions 中不存在相同的属性，则直接添加
            mergedOptions[key] = customOptions[key];
          }
        }
      }
      return mergedOptions;
    }
    function deepCopy(obj) {
      if (typeof obj !== 'object' || obj === null) {
        // 如果是基本数据类型或者null，则直接返回
        return obj;
      }

      // 创建一个新的对象或数组
      const result = Array.isArray(obj) ? [] : {};

      // 遍历原对象的属性或数组的元素，并递归进行深拷贝
      for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          result[key] = deepCopy(obj[key]);
        }
      }

      return result;
    }


    function reasize () {
      myChart.value && myChart.value.resize()
    }

    onMounted(() => {
      renderChart()
      nextTick(() => {
        loadData();
      });
      window.addEventListener('resize', reasize)
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {
      currentProvince,
      returnToChina
    }
  }
})
